/*@flow*/
import type { State, Action } from './types';
import * as I from 'immutable';
import setIn from 'lib/setIn';

const extractDataviewUrls = res => {
  if (!res) return {};
  const v = res.metadata.dataviews;
  return Object.keys(v).reduce((s, k) => ({ ...s, [k]: v[k].url.https }), {});
};

export default (s: State, action: Action): any => {
  let newState = I.fromJS(s);
  const { payload, type } = action;

  switch (type) {
    case 'GEOM_CHANGED':
      // check if geojson is present
      if (payload) {
        // Backup the analyses
        newState = newState.update(v =>
          v.set('mapConfigAnalysisBackup', v.getIn(['mapConfig', 'analyses']))
        );
      } else {
        // Restore the previous analyses
        newState = newState
          .update(v =>
            v.get('mapConfigAnalysisBackup').isEmpty()
              ? v
              : v.setIn(
                  ['mapConfig', 'analyses'],
                  v.get('mapConfigAnalysisBackup')
                )
          )
          .updateIn(['mapConfigAnalysisBackup'], v => v.clear());
      }
      // Set geojson
      newState = newState.set('geojson', payload);

      break;
    case 'INTERSECTION_APPLIED':
      break;
    case 'MAP_FAILED':
      newState = newState.set('cartoError', I.fromJS(payload));
      break;
    case 'MAP_CREATED':
      newState = newState
        .set('dataviewUrls', I.fromJS(extractDataviewUrls(payload)))
        .set('cartoError', undefined);
      break;
    case 'DATA_PANEL_CREATED':
      newState = newState
        .updateIn(['widgetForm'], v => v.clear())
        .updateIn(['placeMetrics'], v => v.unshift(I.fromJS(payload)))
        .updateIn(['selectedMetrics'], v =>
          payload ? v.unshift(payload.id) : v
        )
        .updateIn(['placeMetricsOrder'], v =>
          payload ? v.unshift(payload.id) : v
        )
        .set('mode', 'CUSTOMIZING');
      break;
    case 'DATA_PANEL_MUTATED':
      newState = newState
        .updateIn(['widgetForm'], v => v.clear())
        // Replace existing item with "id"
        .updateIn(['placeMetrics'], v =>
          v.set(
            v.findIndex(v2 => v2.get('id') === (payload && payload.id)),
            I.fromJS(payload)
          )
        )
        .set('mode', 'CUSTOMIZING');
      break;
    case 'DATA_PANEL_DELETED':
      newState = newState
        .update(v => {
          const removeId = v2 => v2.filterNot(v3 => v3.get('id') === payload);
          const remove = v2 => v2.filterNot(v3 => v3 === payload);
          return v
            .update('placeMetrics', removeId)
            .update('selectedMetrics', remove)
            .update('placeMetricsOrder', remove);
        })
        .set('mode', 'CUSTOMIZING');
      break;
    case 'DATA_PANEL_MUTATION_ERROR':
      console.error('error: ', payload);
      newState = newState.set('serverError', I.fromJS(payload));
      break;
    case 'NEW_REQUESTED':
      newState = newState
        .set('mode', 'NEW_WIDGET')
        .set('serverError', undefined);
      break;
    case 'EDIT_REQUESTED':
      newState = newState
        .set('widgetForm', I.fromJS(payload))
        .set('mode', 'EDIT_WIDGET');
      break;
    case 'SET_RECORD':
      if (payload) {
        newState = setIn(newState)(payload);
      }
      break;
    case 'MERGE_RECORD':
      if (payload) {
        newState = newState.merge(I.fromJS(payload));
      }
      break;
    default:
      throw new Error('Unrecognized action `' + type + '`');
  }

  return newState.toJS();
};
